import React from 'react';

const ElementTile = ({
  item,
  onActivate,
  tabIndex = 0,
  buttonRef,
  onKeyDown,
  size = 'regular',
  highlightedTitle,
}) => {
  if (!item) return null;
  const preview = item.preview || {};
  const isDisabled = Boolean(item.disabled);
  const handleActivate = () => {
    if (!isDisabled) {
      onActivate(item);
    }
  };
  return (
    <button
      ref={buttonRef}
      type="button"
      className={`elements-tile elements-tile-${size} ${isDisabled ? 'disabled' : ''}`}
      onClick={handleActivate}
      onKeyDown={onKeyDown}
      tabIndex={tabIndex}
      disabled={isDisabled}
      aria-disabled={isDisabled}
    >
      <div className="elements-tile-preview" aria-hidden="true">
        {preview.type === 'svg' && preview.inlineSvg ? (
          <div
            className="elements-tile-svg"
            dangerouslySetInnerHTML={{ __html: preview.inlineSvg }}
          />
        ) : preview.src ? (
          <img src={preview.src} alt="" loading="lazy" />
        ) : (
          <div className="elements-tile-placeholder" />
        )}
        {isDisabled && <span className="elements-tile-badge">Coming soon</span>}
      </div>
      <div className="elements-tile-title">
        {highlightedTitle || item.title}
      </div>
    </button>
  );
};

export default ElementTile;
